import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@context/AuthContext'
import { useDemo } from '@hooks/useDemo'
import { login as apiLogin } from '@services/auth.service'
import './LoginPage.scss'

const DEMO_EMAIL = 'demo@misslemon.ro'
const DEMO_PASSWORD = 'demo123'

export default function LoginPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { login } = useAuth()
  const isDemo = useDemo()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const from = location.state?.from?.pathname || '/admin'

  async function doLogin(emailVal, passwordVal) {
    setError('')
    setLoading(true)
    try {
      const res = await apiLogin(emailVal.trim(), passwordVal)
      if (res.success && res.token && res.user) {
        login(res.token, res.user)
        navigate(from, { replace: true })
        return
      }
      setError('Răspuns invalid de la server.')
    } catch (err) {
      const message = err.response?.data?.message || err.message || 'Autentificare eșuată.'
      setError(message)
    } finally {
      setLoading(false)
    }
  }

  async function handleSubmit(e) {
    e.preventDefault()
    if (!email.trim() || !password) {
      setError('Introdu emailul și parola.')
      return
    }
    await doLogin(email, password)
  }

  async function handleDemoLogin() {
    await doLogin(DEMO_EMAIL, DEMO_PASSWORD)
  }

  return (
    <div className="login-page">
      <div className="login-page__card">
        <h1 className="login-page__logo">Miss Lemon</h1>
        <p className="login-page__sub">Panou administrare</p>
        {isDemo && (
          <p className="login-page__demo-hint">
            Demo: {DEMO_EMAIL} / {DEMO_PASSWORD}
          </p>
        )}
        <form className="login-page__form" onSubmit={handleSubmit}>
          <div className="admin-form-group">
            <label htmlFor="login-email">Email</label>
            <input
              id="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              disabled={loading}
            />
          </div>
          <div className="admin-form-group">
            <label htmlFor="login-password">Parolă</label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              disabled={loading}
            />
          </div>
          {error && <p className="login-page__error">{error}</p>}
          <button type="submit" className="btn-primary login-page__submit" disabled={loading}>
            {loading ? 'Se încarcă...' : 'Autentificare'}
          </button>
          {isDemo && (
            <button
              type="button"
              className="btn-ghost login-page__demo-btn"
              onClick={handleDemoLogin}
              disabled={loading}
            >
              Login as demo admin
            </button>
          )}
        </form>
      </div>
    </div>
  )
}
